import AlertDetails from './AlertDetails';
import AssetAnalytics from './AssetAnalytics';
import AnalyticsPage from './AnalyticsPage';
import AssetChemical from './AssetChemical';
import AssetChemicalFiles from './AssetChemicalFiles';
import AssetChemicals from './AssetChemicals';
import AssetDetails from './AssetDetails';
import AssetFiles from './AssetFiles';
import AssetMaterial from './AssetMaterial';
import AssetMaterialFiles from './AssetMaterialFiles';
import AssetMaterials from './AssetMaterials';
import AssetsList from './AssetsList';
import AssetTimeline from './AssetTimeline';
import ChemicalAsset from './ChemicalAsset';
import ChemicalDetails from './ChemicalDetails';
import ChemicalFiles from './ChemicalFiles';
import ChemicalsList from './ChemicalsList';
import ContactsList from './ContactsList';
import Guest from './Guest';
import MaterialAsset from './MaterialAsset';
import MaterialDetails from './MaterialDetails';
import MaterialFiles from './MaterialFiles';
import MaterialsList from './MaterialsList';
import OrganizationDetails from './OrganizationDetails';
import OrganizationFiles from './OrganizationFiles';
import OrganizationsList from './OrganizationsList';
import UserDetails from './UserDetails';
import UserFiles from './UserFiles';
import UsersList from './UsersList';
import FilesList from './FilesList';
import AnalyticsLab from './AnalyticsLab';


export default {
  AlertDetails,
  AnalyticsPage,
  AnalyticsLab,
  AssetAnalytics,
  AssetChemical,
  AssetChemicalFiles,
  AssetChemicals,
  AssetDetails,
  AssetFiles,
  AssetMaterial,
  AssetMaterialFiles,
  AssetMaterials,
  AssetsList,
  FilesList,
  AssetTimeline,
  ChemicalAsset,
  ChemicalDetails,
  ChemicalFiles,
  ChemicalsList,
  ContactsList,
  Guest,
  MaterialAsset,
  MaterialDetails,
  MaterialFiles,
  MaterialsList,
  OrganizationDetails,
  OrganizationFiles,
  OrganizationsList,
  UserDetails,
  UserFiles,
  UsersList,
};
